import { withInstall } from "../../utils/index"
import scHelp from './component/ScHelp.vue'
// import { alertProps } from "./component/type"

export const ScHelp = withInstall(scHelp)